import React from "react";
import { Helmet } from "react-helmet";
import LayoutIndex from "../components/layout-index";
import "../components/style.css";

const Index = () => (
  <>
    <Helmet
      defer={false}
      title="N3TWORK Culture Book"
    >
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,600;0,800;1,300&display=swap" rel="stylesheet" />
    </Helmet>
    <div className="layout layout3 orange">
    <LayoutIndex 
      title="Let's Do This" 
      paragraph1 = "Welcome to N3TWORK"
      paragraph2 = "We're glad you're here"
      image={require('../images/illustration-people.svg')?.default} 
    />
    </div>
  </>
);

export default Index;
